<template>
    <v-row align="center">
        <v-col cols="12" class="white-card with-border primary-color caption-light no-shadow">
            <v-row align="center">
                <v-col cols="5">
                    <div class="subheader-heavy">
                        Orden n°{{ order.id }}
                    </div>
                    <div class="mt-1">
                        Fecha {{ date }}
                    </div>
                </v-col>
                <v-col cols="4" class="text-end">
                    <div>
                        {{ order.exams.length }} Exámenes
                    </div>
                    <div v-if="order.atHome">
                        Exámen a domicilio
                    </div>
                </v-col>
                <v-col cols="3">
                    <v-btn class="normal-btn" color="primary" depressed block outlined @click="$emit('click:view')">
                        <v-icon>mdi-eye</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "OrderDownloadCard",
    props: {
        order: {
            type: Object,
            default: null,
        }
    },
    computed: {
        date(vm = this) {
            return vm.$moment(vm.order.created_at).format('DD-MM-YYYY')
        },
    }
}
</script>

<style scoped>

</style>